import { Location } from 'vue-router'
import { Topic as Data } from '@/typings/api/Topic'

import { createEdit, DELETE } from '@/helpers/enums/table-actions'
import { TOPICS_ROUTES as ROUTES } from './utils'


const getEditRoute = (data: Data): Location => ({
  name: ROUTES.EDIT,
  params: { id: data.id.toString() },
})

export const TABLE_ACTIONS = Object.freeze([
  createEdit<Data>(getEditRoute),
  DELETE,
])
export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'id',
    sortable: true,
    width: 80,
  },
  {
    text: 'Название',
    value: 'name',
    sortable: true,
    getRoute: (data: Data) => ({
      name: ROUTES.VIEW,
      params: { id: data.id },
    }),
  },
  {
    text: 'Обратная хронология',
    value: 'reverse_ordering',
    sortable: false,
    field: (value: Data['reverse_ordering']) => (value ? 'Да' : 'Нет'),
    width: 80,
  },
  {
    text: 'Скрыт',
    value: 'is_hidden',
    sortable: false,
    width: 80,
  },
  {
    text: 'Код',
    value: 'slug',
    sortable: false,
  },
])
